<template>
  <div
    class="content"
    style="overflow-y: auto"
    v-loading.fullscreen.lock="fullscreenLoading"
  >
    <div class="fl back-color-fff borderR6 left-tree-box">
      <el-input
        size="mini"
        placeholder="输入关键字进行过滤"
        v-model="filterText"
        style="width: 80%; margin-top: 10px"
      >
      </el-input>

      <el-tree
        :data="superiorOrganization"
        ref="tree"
        class="mt10 mb10"
        :filter-node-method="filterNode"
        :props="defaultPropsOrganisation"
        @node-click="handleNodeCilck"
      >
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span
            style="
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            "
            :title="node.label"
            >{{ node.label }}</span
          >
          <span
            v-if="data.bizState !== 'Y'"
            style="
              flex-shrink: 0;
              display: inline-block;
              width: 48px;
              height: 21px;
              line-height: 21px;
              font-size: 12px;
              background: rgba(239, 239, 239, 0.38);
              border-radius: 11px;
              margin-left: 5px;
              color: #6e6e6e;
            "
            >无效</span
          >
        </span>
      </el-tree>
    </div>

    <div class="right-content-box">
      <div class="search-area">
        <p class="select-node">
          <span class="mr15 fontC-4fa1a4" v-show="$route.query.pageTitle">{{
            $route.query.pageTitle
          }}</span
          >{{ organisationName }}
        </p>
        <el-row :gutter="24">
          <el-col :span="6"
            ><div class="search-area-div">账号</div>
            <el-input
              size="mini"
              v-model="page.logonUser"
              class="ipt-sty"
              placeholder="请输入账号"
            ></el-input
          ></el-col>
          <el-col :span="6">
            <div class="search-area-div">姓名</div>
            <el-input
              size="mini"
              v-model="page.staffName"
              class="ipt-sty"
              placeholder="请输入姓名"
            ></el-input
          ></el-col>
          <el-col :span="6"
            ><div class="search-area-div">手机号</div>
            <el-input
              size="mini"
              v-model="page.mobileNo"
              class="ipt-sty"
              placeholder="请输入手机号"
            ></el-input
          ></el-col>
          <el-col :span="6" class="search-btn-box">
            <el-button
              size="mini"
              type="text"
              @click="showMore = !showMore"
              :icon="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
            >
              {{ showMore ? "收起筛选" : "更多筛选" }}
            </el-button>
            <el-button size="mini" type="info" @click="getData(true)"
              >搜索</el-button
            >
            <el-button size="mini" type="danger" @click="empty">清空</el-button>
          </el-col>
        </el-row>
        <el-row :gutter="24" class="mt15" v-show="showMore">
          <el-col :span="6"
            ><div class="search-area-div">状态</div>
            <el-select
              size="mini"
              v-model="page.bizState"
              clearable
              placeholder="请选择"
              class="ipt-sty"
            >
              <el-option
                v-for="item in bizStateOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <!-- <div class="radio-sty">
                <el-radio v-model="page.bizState" label="Y">有效</el-radio>
                <el-radio v-model="page.bizState" label="S">停用</el-radio>
          </div> -->
          </el-col>
          <!-- <el-col :span="6"><div class="search-area-div">人员类型</div> -->
          <!-- <el-select size="mini" v-model="page.staffType" clearable placeholder="请选择" class="ipt-sty">
          <el-option
            v-for="item in staffTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select> -->
          <!-- <div class="radio-sty">
                <el-radio v-model="page.staffType" label="1" class="radio-ora">组内成员</el-radio>
                <el-radio v-model="page.staffType" label="2" class="radio-ora">备案成员</el-radio>
          </div> -->
          <!-- </el-col> -->
        </el-row>
      </div>
      <div
        class="back-color-fff content-main-box"
        :style="'height:' + contentMainHeight + 'px;'"
      >
        <div class="button-area">
          <!-- <el-button icon="el-icon-plus" size="mini" type="info" @click="add(1, '')">新增人员</el-button> -->
          <!-- <el-button size="mini" type="danger" @click="getDeleteData(1, '')">批量删除</el-button> -->
          <el-button size="mini" type="info" @click="addToPath()"
            >批量审批</el-button
          >
          <div class="fr line-h40 h40 font-S16 mr16">
            有<b class="fontC-4fa1a4"> {{ page.totalRows }} </b>个人员
          </div>
          <!-- <el-button plain size="mini">历史数据</el-button> -->
        </div>
        <el-table
          :data="tableData"
          @selection-change="handleSelectionChange"
          :height="tableHeight"
          stripe
          border
          style="width: 100%"
          v-loading="tableLoading"
        >
          <el-table-column
            type="selection"
            width="60"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            label="序号"
            width="60"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <!-- {{ scope.$index + 1 }} -->
              {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column
            prop="logonUser"
            label="账号"
            width="150"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="staffName"
            label="姓名"
            width="150"
            header-align="center"
            align="center"
          ></el-table-column>
          <!--  <el-table-column
          prop="jobNumber"
          label="工号"
          width="150"
          header-align="center"
          align="center"
        ></el-table-column> -->
          <el-table-column
            prop="mobileNo"
            label="手机号"
            width="150"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="staffType"
            label="人员类型"
            width="150"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row.staffType == '1'"
                class="staff-type staff-inside"
                >组内成员</span
              >
              <span v-else class="staff-type staff-wrap">备案成员</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="organisationNames"
            label="组织"
            width="150"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">{{
              scope.row.organisationName
            }}</template>
          </el-table-column>
          <el-table-column
            prop="positionNames"
            label="岗位"
            width="150"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">{{
              scope.row.positionNames | roleNames
            }}</template>
          </el-table-column>
          <el-table-column
            prop="roleNames"
            label="角色"
            width="150"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">{{
              scope.row.roleNames | roleNames
            }}</template>
          </el-table-column>
          <el-table-column
            prop="bizState"
            label="状态"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row.bizState == 'Y'"
                class="staff-type-biz staff-inside"
                >有效</span
              >
              <span v-else class="staff-type-biz staff-wrap">停用</span>
            </template>
            <!-- <template slot-scope="scope">{{ scope.row.bizState | getBizState }}</template> -->
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="创建时间"
            width="150"
            sortable
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">{{
              scope.row.createTime | getDate
            }}</template>
          </el-table-column>
          <el-table-column
            prop="updateTime"
            label="上次更新时间"
            width="150"
            sortable
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">{{
              scope.row.updateTime | getDate
            }}</template>
          </el-table-column>
          <el-table-column
            label="操作"
            header-align="center"
            width="180"
            align="center"
            fixed="right"
          >
            <template slot-scope="scope">
              <a class="txt-color" @click="add(2, scope.row)">编辑 | </a>
              <a class="txt-color" @click="resetPwd(scope.row.userGuid)"
                >重置密码 |
              </a>
              <a
                class="txt-color-red"
                @click="getDeleteData(2, scope.row.guid, scope.row.tenantGuid)"
                >删除</a
              >
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          class="pt pb back-color-fff"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50, 100, 200]"
          :current-page="page.pageIndex"
          :page-size="page.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.totalRows"
        >
        </el-pagination>
      </div>
    </div>

    <el-dialog
      :title="textTitle"
      :visible.sync="dialogFormVisible"
      width="45%"
      :close-on-click-modal="false"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="140px"
        :label-position="right"
        class="demo-ruleForm"
      >
        <!-- <el-form-item label="货位ID:" prop="allocateNo" v-show="ruleForm.staffType == '2'">
          <el-input  v-model.trim="ruleForm.allocateNo" autocomplete="off" class="w100f"></el-input>
        </el-form-item>  -->
        <el-form-item label="人员名称:" prop="staffName">
          <el-input
            v-model.trim="ruleForm.staffName"
            autocomplete="off"
            class="w100f"
          ></el-input>
        </el-form-item>
        <el-form-item label="人员类型:" class="t-left" prop="staffType">
          <el-radio-group
            @change="staffTypeChange"
            v-model="ruleForm.staffType"
          >
            <el-radio label="1">组内成员</el-radio>
            <el-radio label="2">备案成员</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="身份证号:"
          prop="idCode"
          v-if="ruleForm.staffType == '2'"
        >
          <el-input
            v-model.trim="ruleForm.idCode"
            autocomplete="off"
            class="w100f"
            @blur="checkIdCode"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="工号:" prop="jobNumber">
          <el-input v-model="ruleForm.jobNumber" autocomplete="off" class="w100f"></el-input>
        </el-form-item> -->
        <el-form-item label="账号:" prop="logonUser">
          <el-input
            v-model.trim="ruleForm.logonUser"
            autocomplete="off"
            class="w100f"
          ></el-input>
        </el-form-item>
        <el-form-item label="密码:" prop="pwd">
          <el-input
            v-model.trim="ruleForm.pwd"
            autocomplete="off"
            class="w100f"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号:" prop="mobileNo">
          <el-input
            v-model.trim="ruleForm.mobileNo"
            autocomplete="off"
            @blur="checkIdCode"
            class="w100f"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="初始人员:" class="t-left">
          <el-radio v-model="ruleForm.isTenantInit" label="Y">是</el-radio>
          <el-radio v-model="ruleForm.isTenantInit" label="N">否</el-radio>
        </el-form-item> -->
        <el-form-item label="所属部门:" prop="organisationGuid">
          <el-cascader
            v-model="ruleForm.organisationGuid"
            class="w100f"
            :options="superiorOrganization"
            :show-all-levels="false"
            ref="cascader"
            clearable
            @change="getLevel"
            :props="{
              value: 'guid',
              label: 'organisationName',
              children: 'children',
              checkStrictly: true,
            }"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="岗位:" prop="positionGuids">
          <el-select
            v-model="ruleForm.positionGuids"
            placeholder="请选择"
            class="w100f"
          >
            <el-option
              v-for="po in positionList"
              :key="po.guid"
              :label="po.positionName"
              :value="po.guid"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="角色:" prop="roleGuids">
          <span slot="label">
            <el-popover
              placement="top-start"
              content="可以使用其他人新建的角色，但是不可修改和删除"
              trigger="hover"
            >
              <i slot="reference" class="el-icon-question"></i>
            </el-popover>
            角色:
          </span>
          <el-select
            v-model="ruleForm.roleGuids"
            multiple
            placeholder="请选择"
            class="w100f"
          >
            <el-option
              v-for="ro in roleList"
              :key="ro.guid"
              :label="ro.appSideName + '-' + ro.roleName"
              :value="ro.guid"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="省市县:">
          <citys @incre="incres" :workareaList.sync="workareaList"></citys>
        </el-form-item>
        <el-form-item label="地址:" prop="address">
          <el-input
            v-model="ruleForm.address"
            autocomplete="off"
            class="w100f"
          ></el-input>
        </el-form-item>
        <el-form-item label="邮箱:" prop="email">
          <el-input
            v-model="ruleForm.email"
            autocomplete="off"
            class="w100f"
          ></el-input>
        </el-form-item>
        <el-form-item label="微信:" prop="weChatNo">
          <el-input
            v-model="ruleForm.weChatNo"
            autocomplete="off"
            class="w100f"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="性别:" class="t-left" >
          <el-radio v-model="ruleForm.sex" label="M">男</el-radio>
          <el-radio v-model="ruleForm.sex" label="F">女</el-radio>
        </el-form-item> -->
        <el-form-item label="人员状态:" prop="bizState" class="t-left">
          <el-radio v-model="ruleForm.bizState" label="Y">有效</el-radio>
          <el-radio v-model="ruleForm.bizState" label="S">无效</el-radio>
        </el-form-item>
        <el-form-item
          label="是否管理员:"
          prop="isAdmin"
          class="t-left"
          v-if="ruleForm.staffType == 1"
        >
          <el-radio v-model="ruleForm.isAdmin" label="1">是</el-radio>
          <el-radio v-model="ruleForm.isAdmin" label="0">否</el-radio>
        </el-form-item>
        <el-form-item
          label="药企方名称:"
          prop="sendTenantGuid"
          class="t-left"
          v-show="
            ruleForm.staffType == 1 &&
            allLevel.indexOf('9ec5bc8798d9adca127becb33917cffb') > -1
          "
        >
          <span slot="label"
            >药企方名称
            <el-tooltip
              class="item"
              effect="dark"
              content="用于运营人员分配的药企而设置的，分配后运营人员只能看到被分配的药企的信息；"
              placement="right-start"
              ><i class="el-icon-question"></i
            ></el-tooltip>
          </span>
          <el-select
            v-model="ruleForm.sendTenantGuid"
            filterable
            placeholder="请选择"
            clearable
            class="w100f"
            multiple
            collapse-tags
          >
            <el-option
              v-for="item in tenantListNew"
              :key="item.guid"
              :label="item.name"
              :value="item.guid"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="运营单元:"
          prop="operationUnitGuid"
          class="t-left"
          v-show="ruleForm.staffType == 1"
        >
          <span slot="label"
            >运营单元
            <el-tooltip
              class="item"
              effect="dark"
              content="用于运营人员分配运营单元，设置后该运营人员只能获取被分配的运营单元的数据；"
              placement="right-start"
              ><i class="el-icon-question"></i
            ></el-tooltip>
          </span>
          <el-select
            v-model="ruleForm.operationUnitGuid"
            filterable
            placeholder="请选择"
            clearable
            class="w100f"
            multiple
            collapse-tags
          >
            <el-option
              v-for="item in operationUnitList"
              :key="item.guid"
              :label="item.operationUnitName"
              :value="item.guid"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="运营地域范围:"
          prop="areaList"
          class="t-left"
          v-show="ruleForm.staffType == 1"
        >
          <span slot="label"
            >运营地域范围
            <el-tooltip
              class="item"
              effect="dark"
              content="运营地域范围设置，被设置后，运营人员按照地域来查看在该地域的药企；"
              placement="right-start"
              ><i class="el-icon-question"></i
            ></el-tooltip>
          </span>
          <el-cascader
            :options="addressOptions"
            v-model="ruleForm.areaList"
            style="width: 100%"
            :props="{ multiple: true }"
            clearable
            collapse-tags
          ></el-cascader>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button plain size="mini" @click="dialogFormVisible = false"
          >取消</el-button
        >
        <el-button
          size="mini"
          type="info"
          v-if="textTitle == '新增人员'"
          @click="submitForm('ruleForm')"
          >确定</el-button
        >
        <el-button
          size="mini"
          type="info"
          v-else
          @click="upDateForm('ruleForm')"
          v-loading.fullscreen.lock="fullscreenLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { join } from "lodash";
import areaJson from "../../assets/js/china_address_v4.js";
import citys from "../../components/citys.vue";
import idNumber from "../../assets/js/idNumber.js";
export default {
  components: {
    citys,
  },
  data() {
    const checkPhone = (rule, value, callback) => {
      const phoneReg =
        /^((13[0-9])|(14[0-9])|(15[0-9])|(16[0-9])|(17[0-9])|(18[0-9])|(19[0-9]))\d{8}$/;
      if (!value) {
        return callback(new Error("请输入手机号"));
      }
      setTimeout(() => {
        if (!Number.isInteger(+value)) {
          callback(new Error("请输入数字值"));
        } else {
          if (phoneReg.test(value)) {
            callback();
          } else {
            callback(new Error("手机号格式不正确"));
          }
        }
      }, 100);
    };
    const rulesIdNumber = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入身份证号"));
      }
      setTimeout(() => {
        if (value && idNumber.cnid(value) === false) {
          callback("身份证信息错误");
        } else {
          callback();
        }
      });
    };
    return {
      allLevel: [],
      showMore: false, // 筛选项显示更多，默认否，最多显示三个
      tableHeight: window.innerHeight - 320,
      workareaList: "",
      textTitle: "",
      right: "",
      dialogVisible: false,
      dialogFormVisible: false,
      formLabelWidth: "120px",
      superiorOrganization: [],
      organisationGuidList: [],
      positionList: [],
      roleList: [],
      ruleForm: {
        guid: "",
        tenantGuid: "",
        userGuid: "",
        logonUser: "",
        staffName: "",
        helpCode: "",
        bizState: "Y",
        mobileNo: "",
        email: "",
        isTenantInit: "N",
        leaderGuid: "",
        merchantGuid: "",
        organisationGuid: "",
        positionGuids: "",
        province: "",
        city: "",
        pwd: "",
        district: "",
        venue: "",
        address: "",
        sex: "",
        staffType: "2",
        remark: "",
        weChatNo: "",
        weChatOpentId: "",
        idCode: "",
        roleGuids: [],
        sendTenantGuid: [],
        areaList: [],
        operationUnitGuid: [],
        isAdmin: "0",
        // allocateNo:''
      },
      defaultPropsOrganisation: {
        id: "guid",
        label: "organisationName",
        children: "children",
      },
      // defaultPropsOrganisationCascader:{
      //    value: "guid",
      //    label: "organisationName",
      //    children:"children"
      // },
      page: {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: "",
        logonUser: "",
        staffName: "",
        mobileNo: "",
        staffType: "2",
        bizState: "",
        organisationGuid: "",
        approvalState: "N",
      },
      staffDetail: "",
      tableData: [],
      rules: {
        staffName: [
          { required: true, message: "请输入人员名称", trigger: "blur" },
          { min: 1, max: 30, message: "长度在 3 到 5 个字符", trigger: "blur" },
        ],
        idCode: [{ required: true, validator: rulesIdNumber, trigger: "blur" }],
        logonUser: [{ required: true, message: "请输入账号", trigger: "blur" }],
        mobileNo: [{ required: true, validator: checkPhone, trigger: "blur" }],
        organisationGuid: [
          { required: true, message: "请输入所属部门", trigger: "blur" },
          // { message: '长度在 3 到 5 个字符', trigger: 'blur' },
        ],
        positionGuids: [
          { required: true, message: "请输入岗位", trigger: "blur" },
          { message: "长度在 3 到 5 个字符", trigger: "blur" },
        ],
        roleGuids: [
          { required: true, message: "请输入角色", trigger: "blur" },
          // { message: '长度在 3 到 5 个字符', trigger: 'blur' },
        ],
      },
      filterText: "",
      multipleSelection: [],
      tableLoading: false,
      tenantList: [],
      // 药企数据
      tenantListNew: [],
      addressOptions: areaJson,
      operationUnitList: [],
      fullscreenLoading: false,
      tenantName: "",
      deleteTips: null,

      bizStateOptions: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "Y",
          label: "有效",
        },
        {
          value: "S",
          label: "停用",
        },
      ],
      staffTypeOptions: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "1",
          label: "组内成员",
        },
        {
          value: "2",
          label: "备案成员",
        },
      ],
      organisationName: "",
      editMobileNo: "",
      isCheckIdCard: "Y",
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    showMore(val, oldVal) {
      if (val) {
        this.tableHeight = window.innerHeight - 380;
        return;
      }
      if (!val) {
        this.tableHeight = window.innerHeight - 320;
        return;
      }
    },
  },
  created() {
    // this.tenantName = this.$route.query.tenantName;
    // 列表
    this.getData(false);
    this.getSuperiorOrganization();
    this.getAppsideData();
    this.getPositionListData();
    this.getTenantOperationRelList();
    this.getOperationUnitList();
    this.getIsCheck();
  },
  methods: {
    staffTypeChange() {
      this.ruleForm.idCode = "";
      this.$refs.ruleForm.clearValidate();
    },
    getIsCheck() {
      let that = this;
      // let id = '1aaf025422ff11eb9405080027ac9e40';
      // if(location.href.indexOf('https://scm-operation.csyaoly.com') > -1){
      //   id = '89a3261c262411ebad37fa163e4b37cf'
      // }else{
      //   id = '1aaf025422ff11eb9405080027ac9e40'
      // }
      that.api
        .get(
          `/${serverConfig.msConfigureService}/sysparameter/data/get-detail-grp?tenantGuid=${localStorage.guid}&code=HMCLJ`
        )
        .then((resp) => {
          console.log(resp.data);
          if (resp.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let data = resp.data.data;
            let arr = [];
            if (data && data.length > 0) {
              that.isCheckIdCard = data[0].parameterValue;
            }
            // data.forEach((item) => {
            //   if(item.parameterValue == this.$route.query.tenantGuid){
            //     that.isAllocateNo = true;
            //     console.log(that.isAllocateNo)
            //   }
            // });
          }
        });
    },
    renderContent(h, { node, data, store }) {
      if (data.bizState !== "Y") {
        return (
          <span>
            {node.label}{" "}
            <span style="display: inline-block;width: 48px;height: 21px;line-height: 21px;font-size:12px;background: rgba(239, 239, 239, 0.38);border-radius: 11px;margin-left: 5px;color:#6E6E6E;">
              无效
            </span>
          </span>
        );
      } else {
        return <span>{node.label}</span>;
      }
    },
    resetPwd(guid) {
      let self = this;
      self.fullscreenLoading = true;
      self.api
        .get(
          `/${serverConfig.msCommonAdminPlatformAuthService}/user/data/resetPwd?userGuid=${guid}`
        )
        .then((res) => {
          self.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.$message.success("重置密码成功，密码为：Aa666666+");
            self.getData(true);
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    addToPath() {
      if (this.multipleSelection.length == 0) {
        this.$message.error("请勾选需要审批的数据！");
        return;
      }
      // let req = {
      //   guids:this.multipleSelection
      // }

      this.fullscreenLoading = true;
      this.api
        .postJson(
          `/${serverConfig.msPersonnelService}/staff/batch-approve`,
          this.multipleSelection
        )
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.$message.success("审核成功！");
            this.getData(true);
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    //运营获取药企
    getTenantOperationRelList() {
      let self = this;
      self.api
        .postJson(
          `/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`,
          { tenantGuid: self.$store.getters.getTenantGuid, isService: true }
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tenantList = res.data.data;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //检查花名册中是否存在
    checkIdCode() {
      if (this.isCheckIdCard !== "Y") {
        return;
      }
      if (this.ruleForm.staffType !== "2") {
        return;
      }
      if (!this.ruleForm.idCode || !this.ruleForm.mobileNo) {
        return;
      }
      let _IDRe18 =
        /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      if (this.ruleForm.idCode && !_IDRe18.test(this.ruleForm.idCode)) {
        this.ruleForm.idCode = "";
        this.$message.error("请输入正确身份证号");
        return;
      }
      let self = this;
      if (
        this.ruleForm.idCode &&
        this.ruleForm.mobileNo &&
        this.ruleForm.staffType == 2
      ) {
        self.api
          .get(
            `/${serverConfig.msPersonnelService}/staff-roster/get-exist-roster?mobileNo=${this.ruleForm.mobileNo}&idCode=${this.ruleForm.idCode}&tenantGuid=${localStorage.guid}`
          )
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              if (res.data.data == false) {
                self.$message.error(
                  "该备案人员花名册不存在，请先至花名册维护！"
                );
              }
            } else {
              self.$message.error(res.data.msg);
            }
          });
      }
    },
    //运营单元列表
    getOperationUnitList() {
      let self = this;
      self.api
        .postJson(
          `/${serverConfig.msPersonnelService}/operationunit/data/get`,
          {
            tenantGuid: self.$store.getters.getTenantGuid,
            pageIndex: 1,
            pageSize: -1,
          }
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.operationUnitList = res.data.data.records;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    incres(area) {
      let self = this;
      self.ruleForm.province = area[0];
      self.ruleForm.city = area[1];
      self.ruleForm.district = area[2];
    },
    handleNodeCilck(data) {
      // console.log(data);
      let self = this;
      self.page.organisationGuid = data.guid;
      self.organisationName = data.organisationName;
      self.getData(true);
      // node.
    },
    getSuperiorOrganization() {
      let self = this;
      let tenantGuid = self.$store.getters.getTenantGuid;
      self.api
        .get(
          `/${serverConfig.msPersonnelService}/organisation/data/get-organisation-detail?` +
            `tenantGuid=` +
            tenantGuid
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.superiorOrganization = res.data.data;
            if (
              self.superiorOrganization &&
              self.superiorOrganization.length > 0
            ) {
              self.organisationName =
                self.superiorOrganization[0].organisationName;
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    getAppsideData() {
      let self = this;
      let promise = {
        guid: "",
        pageIndex: 1,
        appSideName: "",
        pageSize: 10,
        platformGuid: "",
        startTime: "",
        endTime: "",
      };
      self.api
        .postJson(
          `/${serverConfig.msCommonAdminPlatformAuthService}/appside/data/get`,
          promise
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let appsideList = res.data.data.records;
            self.roleList = [];
            appsideList.forEach(function (i) {
              self.getRoleListData(i.guid);
            });
            // self.page.totalPage = res.data.data.totalPages;
            // self.page.totalRows = res.data.data.totalRows;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    getRoleListData(guid) {
      let self = this;
      // self.page.appSideGuid = 'f2cb03a2b3e84149df939753f9825054';
      let promise = {
        bizState: "Y",
        tenantGuid: self.page.tenantGuid,
        appSideGuid: guid,
        pageSize: 1000,
      };
      self.api
        .postJson(
          `/${serverConfig.msCommonAdminPlatformAuthService}/role/data/get`,
          promise
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let roleList = res.data.data.records;
            if (roleList != null) {
              roleList.forEach(function (j) {
                let item = {
                  guid: j.guid,
                  roleName: j.roleName,
                  appSideName: j.appSideName,
                };
                self.roleList.push(item);
              });
            }
            console.log(self.roleList.length);
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    getPositionListData() {
      let self = this;
      let promise = {
        tenantGuid: self.page.tenantGuid,
        pageSize: 10000,
      };
      self.api
        .postJson(
          `/${serverConfig.msPersonnelService}/position/data/get`,
          promise
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.positionList = res.data.data.records;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.organisationName.indexOf(value) !== -1;
    },
    empty() {
      let self = this;
      self.page = {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: "",
        logonUser: "",
        staffName: "",
        mobileNo: "",
        staffType: "2",
        bizState: "",
        organisationGuid: "",
        approvalState: "N",
      };
      self.organisationName = "";
      self.getData(true);
    },
    add(flg, row) {
      let self = this;
      self.workareaList = [];
      // 清空组织勾选的数据
      self.allLevel = [];

      if (flg == 1) {
        self.textTitle = "新增人员";
        // self.ruleForm.jobNumber = '';
        self.ruleForm.logonUser = "";
        self.ruleForm.staffName = "";
        self.ruleForm.bizState = "Y";
        self.ruleForm.mobileNo = "";
        self.ruleForm.email = "";
        self.ruleForm.isTenantInit = "N";
        self.ruleForm.leaderGuid = "";
        self.ruleForm.merchantGuid = "";
        self.ruleForm.organisationGuid = "";
        self.ruleForm.positionGuids = "";
        self.ruleForm.province = "";
        self.ruleForm.city = "";
        self.ruleForm.pwd = "";
        self.ruleForm.district = "";
        self.ruleForm.venue = "";
        self.ruleForm.address = "";
        self.ruleForm.sex = "";
        self.ruleForm.staffType = "2";
        self.ruleForm.remark = "";
        self.ruleForm.weChatNo = "";
        self.ruleForm.weChatOpentId = "";
        self.ruleForm.weChatOpentId = "";
        self.ruleForm.idCode = "";
        self.ruleForm.roleGuids = [];
        self.ruleForm.guid = "";
        self.ruleForm.isAdmin = "0";

        // 新增的时候，清空药企方名称 运营单元 运营地域范围所选的数据
        self.ruleForm.sendTenantGuid = [];
        self.ruleForm.operationUnitGuid = [];
        self.ruleForm.areaList = [];

        self.dialogFormVisible = true;
      } else {
        console.log(row);
        self.textTitle = "编辑人员";
        self.ruleForm.guid = row.guid;
        self.workareaList.push(row.province, row.city, row.district);
        self.getStaffDetail(row.guid);
      }
    },
    getData(flg) {
      let self = this;
      if (flg) {
        self.page.pageIndex = 1;
      }
      self.page.tenantGuid = self.$store.getters.getTenantGuid;
      self.tableLoading = true;
      self.api
        .postJson(
          `/${serverConfig.msPersonnelService}/staff/data/get`,
          self.page
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tableLoading = false;
            self.tableData = res.data.data.records;
            self.page.totalPage = res.data.data.totalPages;
            self.page.totalRows = res.data.data.totalRows;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    getStaffDetail(guid) {
      let self = this;
      self.staffDetail = "";
      self.ruleForm.sendTenantGuid = [];
      self.ruleForm.operationUnitGuid = [];
      self.ruleForm.areaList = [];
      self.fullscreenLoading = true;
      self.api
        .get(
          `/${serverConfig.msPersonnelService}/staff/data/get-staff-detail?` +
            `guid=` +
            guid
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.staffDetail = res.data.data;
            self.editMobileNo = JSON.parse(
              JSON.stringify(res.data.data.mobileNo)
            );
            let guids = [];
            self.ruleForm.userGuid = self.staffDetail.userGuid;
            self.ruleForm.logonUser = self.staffDetail.logonUser;
            self.ruleForm.staffName = self.staffDetail.staffName;
            self.ruleForm.bizState = self.staffDetail.bizState;
            self.ruleForm.mobileNo = self.staffDetail.mobileNo;
            self.ruleForm.email = self.staffDetail.email;
            self.ruleForm.pwd = "";
            self.ruleForm.isTenantInit = self.staffDetail.isTenantInit;
            self.ruleForm.leaderGuid = self.staffDetail.leaderGuid;
            self.ruleForm.merchantGuid = self.staffDetail.merchantGuid;
            self.ruleForm.organisationGuid = self.staffDetail.organisationGuid;
            if (self.staffDetail.positionGuids) {
              self.ruleForm.positionGuids = self.staffDetail.positionGuids[0];
            }
            self.ruleForm.province = self.staffDetail.province;
            self.ruleForm.city = self.staffDetail.city;
            self.ruleForm.district = self.staffDetail.district;
            self.ruleForm.venue = self.staffDetail.venue;
            self.ruleForm.address = self.staffDetail.address;
            self.ruleForm.sex = self.staffDetail.sex;
            self.ruleForm.staffType = self.staffDetail.staffType;
            self.ruleForm.remark = self.staffDetail.remark;
            self.ruleForm.weChatNo = self.staffDetail.weChatNo;
            self.ruleForm.weChatOpentId = self.staffDetail.weChatOpentId;
            self.ruleForm.isAdmin =
              self.staffDetail.staffType == 1 ? self.staffDetail.isAdmin : null;
            if (self.staffDetail.operationStaffTenantManageList) {
              self.staffDetail.operationStaffTenantManageList.forEach((i) => {
                self.ruleForm.sendTenantGuid.push(i.sendTenantGuid);
              });
            }
            if (self.staffDetail.operationUnitStaffList) {
              self.staffDetail.operationUnitStaffList.forEach((j) => {
                self.ruleForm.operationUnitGuid.push(j.operationUnitGuid);
              });
            }
            if (self.staffDetail.operationStaffAreaRangeList) {
              self.staffDetail.operationStaffAreaRangeList.forEach((m) => {
                if (m.city == null) {
                  self.ruleForm.areaList.push([m.province]);
                } else if (m.district == null) {
                  self.ruleForm.areaList.push([m.province, m.city]);
                  // i.district = '';
                } else {
                  self.ruleForm.areaList.push([m.province, m.city, m.district]);
                }
              });
            }
            // console.log(self.ruleForm.areaList);
            self.ruleForm.idCode = self.staffDetail.idCode;
            self.ruleForm.roleGuids = self.staffDetail.roleGuids;
            setTimeout(function () {
              self.fullscreenLoading = false;
              self.dialogFormVisible = true;

              //  获取选择的nodes
              self.$nextTick(() => {
                let nodes = self.$refs["cascader"].getCheckedNodes();
                // console.log('获取选择的nodes')
                // console.log(nodes[0])
                // 获取所有节点guid
                let level = nodes[0]["pathNodes"] || [];
                level.forEach((item) => {
                  self.allLevel.push(item.value);
                });
                // 获取当前节点的值
                let datas = nodes[0]["data"] || [];
                if (datas.distributeTenant) {
                  self.tenantListNew = JSON.parse(datas.distributeTenant);
                }
              });
            }, 1000);
          } else {
            self.fullscreenLoading = false;
            self.$message.error(res.data.msg);
          }
        });
    },
    handleSelectionChange(val) {
      let self = this;
      self.multipleSelection = [];
      val.forEach(function (item) {
        self.multipleSelection.push(item.guid);
      });
    },
    //获取客户列表
    getCustomerList(tenantGuid, staffGuid) {
      let self = this;
      let query = {
        tenantGuid,
        staffGuid: [staffGuid],
      };
      this.deleteTips = null;
      return new Promise((resolve, reject) => {
        self.api
          .postJson(
            `/${serverConfig.msPersonnelService}/duty-transform/filing-staff-get-customer`,
            query
          )
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              let data = res.data.data;
              if (data) {
                data.forEach((i) => {
                  if (
                    i.customerInfo.customer ||
                    i.customerInfo.doctors ||
                    i.customerInfo.franchisees ||
                    i.customerInfo.medList ||
                    i.customerInfo.patients ||
                    i.customerInfo.potentialCustomer ||
                    i.customerInfo.potentialFranchisees
                  ) {
                    this.deleteTips =
                      "此人员存在客户数据，请先办理离职，交接客户资源后，才可删除！";
                  }
                });
              }
              resolve();
            } else {
              self.$message.error(res.data.msg);
            }
          });
      });
    },
    async getDeleteData(flg, guid, tenantGuid) {
      let self = this;
      if (flg == 1) {
        if (self.multipleSelection.length == 0) {
          self.$message.error("请勾选数据！");
          return;
        }
      } else {
        self.multipleSelection = [];
        self.multipleSelection.push(guid);
      }
      let DeleteStaffRequestVO = {
        guids: self.multipleSelection,
        tenantGuid: self.$store.getters.getTenantGuid,
        isVaildInitStaff: true,
      };
      await this.getCustomerList(tenantGuid, guid);
      if (this.deleteTips) {
        self.$message.error(this.deleteTips);
        return;
      }
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          self.api
            .postJson(
              `/${serverConfig.msPersonnelService}/staff/data/delete-by-tenant`,
              DeleteStaffRequestVO
            )
            .then((res) => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.multipleSelection = [];
                self.$message.success("删除人员成功");
                self.getData(true);
              } else {
                self.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    submitForm(formName) {
      let self = this;
      if (!self.ruleForm.pwd) {
        self.$message.error("密码不能为空！");
        return;
      }
      let positionGuids = [];
      let operationStaffTenantManageList = [];
      let operationUnitStaffList = [];
      let operationStaffAreaRangeList = [];
      let venue = "";
      positionGuids.push(self.ruleForm.positionGuids);
      if (
        self.ruleForm.sendTenantGuid != null &&
        self.ruleForm.sendTenantGuid.length > 0
      ) {
        self.ruleForm.sendTenantGuid.forEach((i) => {
          let item = {
            sendTenantGuid: i,
          };
          operationStaffTenantManageList.push(item);
        });
      }
      if (
        self.ruleForm.operationUnitGuid != null &&
        self.ruleForm.operationUnitGuid.length > 0
      ) {
        self.ruleForm.operationUnitGuid.forEach((i) => {
          let item1 = {
            operationUnitGuid: i,
          };
          operationUnitStaffList.push(item1);
        });
      }
      if (self.ruleForm.areaList != null && self.ruleForm.areaList.length > 0) {
        self.ruleForm.areaList.forEach((i) => {
          self.addressOptions.forEach(function (j) {
            if (i[0] == j.value) {
              venue = j.label;
            }
          });
          if (i[1]) {
            self.addressOptions.forEach(function (j) {
              if (i[0] == j.value) {
                if (j.children != null && j.children != "") {
                  j.children.forEach(function (k) {
                    if (i[1] == k.value) {
                      venue = j.label + "/" + k.label;
                    }
                  });
                }
              }
            });
          }
          if (i[2]) {
            self.addressOptions.forEach(function (j) {
              if (i[0] == j.value) {
                if (j.children != null && j.children != "") {
                  j.children.forEach(function (k) {
                    if (i[1] == k.value) {
                      if (k.children != null && k.children != "") {
                        k.children.forEach(function (g) {
                          if (i[2] == g.value) {
                            venue = j.label + "/" + k.label + "/" + g.label;
                          }
                        });
                      }
                    }
                  });
                }
              }
            });
          }
          let item2 = {
            province: i[0],
            city: i[1],
            district: i[2],
            venue: venue,
          };
          operationStaffAreaRangeList.push(item2);
        });
      }
      self.$refs[formName].validate((valid) => {
        if (valid) {
          let pwd = self.$md5(self.ruleForm.pwd);
          let organisationGuids = [];
          organisationGuids.push(self.ruleForm.organisationGuid);
          let promise = {
            tenantGuid: self.page.tenantGuid,
            // jobNumber: self.ruleForm.jobNumber,
            logonUser: self.ruleForm.logonUser,
            staffName: self.ruleForm.staffName,
            helpCode: self.ruleForm.helpCode,
            pwd: pwd,
            bizState: self.ruleForm.bizState,
            mobileNo: self.ruleForm.mobileNo,
            email: self.ruleForm.email,
            isTenantInit: self.ruleForm.isTenantInit,
            leaderGuid: self.ruleForm.leaderGuid,
            merchantGuid: self.ruleForm.merchantGuid,
            // organisationGuid: self.ruleForm.organisationGuid,
            organisationGuids: organisationGuids,
            positionGuids: positionGuids,
            province: self.ruleForm.province,
            city: self.ruleForm.city,
            district: self.ruleForm.district,
            venue: self.ruleForm.venue,
            address: self.ruleForm.address,
            sex: self.ruleForm.sex,
            staffType: self.ruleForm.staffType,
            isAdmin:
              self.ruleForm.staffType == 1 ? self.ruleForm.isAdmin : null,
            remark: self.ruleForm.remark,
            weChatNo: self.ruleForm.weChatNo,
            weChatOpentId: self.ruleForm.weChatOpentId,
            idCode: self.ruleForm.idCode,
            roleGuids: self.ruleForm.roleGuids,
            operationStaffTenantManageList: operationStaffTenantManageList,
            operationUnitStaffList: operationUnitStaffList,
            operationStaffAreaRangeList: operationStaffAreaRangeList,
          };
          if (promise.logonUser !== promise.mobileNo) {
            this.$message.error("账号和手机号请保持一致！");
            return;
          }
          self.fullscreenLoading = true;
          self.api
            .postJson(
              `/${serverConfig.msPersonnelService}/staff/data/add`,
              promise
            )
            .then((res) => {
              self.fullscreenLoading = false;
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.dialogFormVisible = false;
                self.$message.success("添加人员成功");
                self.getData(true);
              } else {
                self.$message.error(res.data.msg);
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    upDateForm(formName) {
      let self = this;
      let positionGuids = [];
      let operationStaffTenantManageList = [];
      let operationUnitStaffList = [];
      let operationStaffAreaRangeList = [];
      let venue = "";
      positionGuids.push(self.ruleForm.positionGuids);
      if (
        self.ruleForm.sendTenantGuid != null &&
        self.ruleForm.sendTenantGuid.length > 0
      ) {
        self.ruleForm.sendTenantGuid.forEach((i) => {
          let item = {
            sendTenantGuid: i,
          };
          operationStaffTenantManageList.push(item);
        });
      }
      if (
        self.ruleForm.operationUnitGuid != null &&
        self.ruleForm.operationUnitGuid.length > 0
      ) {
        self.ruleForm.operationUnitGuid.forEach((i) => {
          let item1 = {
            operationUnitGuid: i,
          };
          operationUnitStaffList.push(item1);
        });
      }
      if (self.ruleForm.areaList != null && self.ruleForm.areaList.length > 0) {
        self.ruleForm.areaList.forEach((i) => {
          self.addressOptions.forEach(function (j) {
            if (i[0] == j.value) {
              venue = j.label;
            }
          });
          if (i[1]) {
            self.addressOptions.forEach(function (j) {
              if (i[0] == j.value) {
                if (j.children != null && j.children != "") {
                  j.children.forEach(function (k) {
                    if (i[1] == k.value) {
                      venue = j.label + "/" + k.label;
                    }
                  });
                }
              }
            });
          }
          if (i[2]) {
            self.addressOptions.forEach(function (j) {
              if (i[0] == j.value) {
                if (j.children != null && j.children != "") {
                  j.children.forEach(function (k) {
                    if (i[1] == k.value) {
                      if (k.children != null && k.children != "") {
                        k.children.forEach(function (g) {
                          if (i[2] == g.value) {
                            venue = j.label + "/" + k.label + "/" + g.label;
                          }
                        });
                      }
                    }
                  });
                }
              }
            });
          }
          let item2 = {
            province: i[0],
            city: i[1],
            district: i[2],
            venue: venue,
          };
          operationStaffAreaRangeList.push(item2);
        });
      }
      self.$refs[formName].validate((valid) => {
        if (valid) {
          let pwd = self.$md5(self.ruleForm.pwd);
          let organisationGuids = [];
          organisationGuids.push(self.ruleForm.organisationGuid);
          let promise = {
            guid: self.ruleForm.guid,
            tenantGuid: self.page.tenantGuid,
            sendTenantGuid: self.page.tenantGuid,
            userGuid: self.ruleForm.userGuid,
            logonUser: self.ruleForm.logonUser,
            staffName: self.ruleForm.staffName,
            helpCode: self.ruleForm.helpCode,
            pwd: pwd,
            bizState: self.ruleForm.bizState,
            mobileNo: self.ruleForm.mobileNo,
            email: self.ruleForm.email,
            isTenantInit: self.ruleForm.isTenantInit,
            leaderGuid: self.ruleForm.leaderGuid,
            merchantGuid: self.ruleForm.merchantGuid,
            // organisationGuid: self.ruleForm.organisationGuid,
            organisationGuids: organisationGuids,
            positionGuids: positionGuids,
            province: self.ruleForm.province,
            city: self.ruleForm.city,
            district: self.ruleForm.district,
            venue: self.ruleForm.venue,
            address: self.ruleForm.address,
            sex: self.ruleForm.sex,
            staffType: self.ruleForm.staffType,
            isAdmin:
              self.ruleForm.staffType == 1 ? self.ruleForm.isAdmin : null,
            remark: self.ruleForm.remark,
            weChatNo: self.ruleForm.weChatNo,
            weChatOpentId: self.ruleForm.weChatOpentId,
            idCode: self.ruleForm.idCode,
            roleGuids: self.ruleForm.roleGuids,
            operationStaffTenantManageList: operationStaffTenantManageList,
            operationUnitStaffList: operationUnitStaffList,
            operationStaffAreaRangeList: operationStaffAreaRangeList,
          };
          if (promise.logonUser !== promise.mobileNo) {
            this.$message.error("账号和手机号请保持一致！");
            return;
          }
          // self.fullscreenLoading = true;
          if (self.editMobileNo == promise.mobileNo || !self.ruleForm.guid) {
            self.fullscreenLoading = true;
            self.api
              .put(
                `/${serverConfig.msPersonnelService}/staff/data/update`,
                promise
              )
              .then((res) => {
                self.fullscreenLoading = false;
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                  self.dialogFormVisible = false;
                  self.$message.success("编辑人员成功");
                  self.getData(true);
                } else {
                  self.$message.error(res.data.msg);
                }
              });
          } else {
            self
              .$confirm("手机号有变更，确定修改吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              })
              .then(() => {
                self.fullscreenLoading = true;
                self.api
                  .put(
                    `/${serverConfig.msPersonnelService}/staff/data/update`,
                    promise
                  )
                  .then((res) => {
                    self.fullscreenLoading = false;
                    if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                      self.dialogFormVisible = false;
                      self.$message.success("编辑人员成功");
                      self.getData(true);
                    } else {
                      self.$message.error(res.data.msg);
                    }
                  });
              })
              .catch(() => {
                self.$message({
                  type: "info",
                  message: "已取消操作",
                });
              });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
    getLevel(val) {
      let self = this;
      console.log("789", val, val.length);
      self.allLevel = val; // 存放搜索勾选的guid,包含父级
      if (val.length > 0) {
        self.ruleForm.organisationGuid = val[val.length - 1].toString();
      }
      this.$nextTick(() => {
        let nodes = self.$refs["cascader"].getCheckedNodes();
        // console.log('获取选择的nodes')
        // console.log(nodes)

        // 选择不同的组织时，清空勾选的药企数据，清空药企下拉选数据，重新赋值
        self.ruleForm.sendTenantGuid = [];
        self.tenantListNew = [];

        let datas = nodes[0]["data"] || [];
        if (datas["distributeTenant"]) {
          self.tenantListNew = JSON.parse(datas.distributeTenant);
          // console.log(self.tenantListNew)
        }
      });
      // console.log(self.ruleForm.level);
    },
  },
};
</script>
<style lang="less" scoped>
.el-col-5 {
  width: 33%;
}
.ipt-sty {
  width: 69% !important;
}
/deep/.el-tree-node__label {
  width: 80%;
  white-space: normal;
  overflow: hidden;
  text-align: left;
}
.el-tree-node__content {
  height: auto;
}
.radio-ora {
  margin-right: 12px;
}
.staff-type {
  display: inline-block;
  width: 72px;
  height: 28px;
  line-height: 28px;
  color: #4fa1a4;
  background: rgba(234, 248, 248, 0.39);
  border-radius: 2px;
}
.staff-type-biz {
  display: inline-block;
  width: 52px;
  height: 28px;
  line-height: 28px;
  color: #4fa1a4;
  background: rgba(234, 248, 248, 0.39);
  border-radius: 2px;
}
.staff-wrap {
  color: #d8814b;
  background: rgba(255, 238, 224, 0.39);
}
.biz-state {
  display: inline-block;
  width: 48px;
  height: 21px;
  line-height: 21px;
  background: rgba(239, 239, 239, 0.38);
  border-radius: 11px;
  margin-left: 5px;
}
.select-node {
  margin: 0 0 17px 0;
  text-align: left;
  font-size: 18px;
  color: #323233;
}
.custom-tree-node {
  display: inline-flex;
  overflow: hidden;
}
.content-main-box {
  height: calc(100vh - 60px - 35px - 66px - 36px);
}
/* .el-pagination {
  width: calc(100% - 260px - 231px);
} */
</style>
